import React from 'react'
import { ImageManager } from 'Core/imageManager'
import { Wrapper } from 'SRC/ui/FormElements'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setNewLogo } from '../../../../../actions'
import { getUserInfo, getNewLogo } from '../../../../../selectors'
import { imagesCDN } from 'Core/constants'
import { Preloader } from 'SRC/ui/Preloader'

export class Image extends React.Component {
  constructor (props) {
    super(props)

    this.imageManager = new ImageManager()
    this.maxWidth = 200
    this.maxHeight = 150
    this.state = {isLoading: true}
    this.isComponentMounted = true
  }

  async componentDidMount () {
    if (this.props.existingLogo) {
      const arStrings = this.props.existingLogo.split('/')
      const name = arStrings[arStrings.length - 1]
      this.imageManager.loadImageFromUrl(`${imagesCDN}${this.props.existingLogo}`).then(image => {
        if (this.isComponentMounted) {
          this.props.setNewLogo({file: image.file, name, isOriginal: true})
          this.setState({...this.state, isLoading: false})
        }
      }).catch(() => {
        if (this.isComponentMounted) {
          this.props.setNewLogo({file: '', name})
          this.setState({...this.state, isLoading: false})
        }
      })
    } else {
      this.setState({...this.state, isLoading: false})
    }
  }

  componentWillUnmount () {
    this.isComponentMounted = false
  }

  onChange = e => {
    if (!this.props.isFormBlocked) {
      const image = e.target.files[0]
      this.imageManager.loadImage(image).then(
        file => this.imageManager.resizeImage(file, {width: this.maxWidth, height: this.maxHeight})
      ).then(
        file => this.props.setNewLogo({file, name: image.name})
      )
    }
  }

  rotateLeft = () => {
    if (!this.props.isFormBlocked && this.props.newLogo.file) {
      this.imageManager.rotateLeft(this.props.newLogo.file).then(file => {
        this.props.setNewLogo({name: this.props.newLogo.name, file})
      })
    }
  }

  rotateRight = () => {
    if (!this.props.isFormBlocked && this.props.newLogo.file) {
      this.imageManager.rotateRight(this.props.newLogo.file).then(file => {
        this.props.setNewLogo({name: this.props.newLogo.name, file})
      })
    }
  }

  removeImage = () => {
    if (!this.props.isFormBlocked) {
      this.props.setNewLogo(null)
    }
  }

  render () {
    return [
      <input
        id='logo'
        name='logo'
        type='file'
        accept={this.imageManager.allowedTypes.join(',')}
        style={{display: 'none'}}
        onChange={this.onChange}
        key='input'
        disabled={this.props.isFormBlocked}
      />,
      !this.props.newLogo && !this.props.existingLogo
        ? <Wrapper isFullWidth key='addLogoBtn'>
          <label className='dodaj-logo' htmlFor='logo' key='label' style={{textAlign: 'center'}}>
            <i className='ico-tab-fotografije ico' />
            Dodaj logo
          </label>
        </Wrapper>
        : <div className='dodaj-logo-group' style={{marginBottom: '15px'}} key='editLogo'>
          {this.state.isLoading
            ? <Preloader />
            : <div className='logo-img' key='logo'>
              {this.props.newLogo && this.props.newLogo.file ? <img src={this.props.newLogo.file} /> : null}
            </div>
          }
          <div className='logo-btns' key='buttons'>
            <label htmlFor='logo'><i className='ico ico-poslate-poruke' />Dodaj</label>
            <a
              onClick={this.removeImage}
              style={this.props.newLogo && this.props.newLogo.file ? null : {display: 'none'}}
            >
              <i className='ico ico-obrisati' />Obriši
            </a>
            <div className='image-rotate'>
              <a
                style={this.props.newLogo && this.props.newLogo.file ? null : {display: 'none'}}
                onClick={this.rotateLeft}
              >
                &#8634;
              </a>
              <a
                onClick={this.rotateRight}
                style={this.props.newLogo && this.props.newLogo.file ? null : {display: 'none'}}
              >
                &#8635;
              </a>
            </div>
          </div>
        </div>
    ]
  }
}

Image.propTypes = {
  newLogo: PropTypes.shape({
    file: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isOriginal: PropTypes.bool
  }),
  setNewLogo: PropTypes.func.isRequired,
  isFormBlocked: PropTypes.bool.isRequired,
  existingLogo: PropTypes.string
}

Image.defaultProps = {
  isFormBlocked: false
}

const mapStateToProps = state => {
  const props = {newLogo: getNewLogo(state)}
  const userInfo = getUserInfo(state)
  if (userInfo.media && Array.isArray(userInfo.media)) {
    const logo = userInfo.media.filter(item => item.title === 'profile-picture')
    if (logo.length) {
      props.existingLogo = logo[0].fd
    }
  }
  return props
}

export default connect(mapStateToProps, {setNewLogo})(Image)
